module.exports = __webpack_public_path__ + "static/img/eslogo.f16a7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eslogo.png
// module id = Uwef
// module chunks = 31